import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) { navigate("/"); return; }
    (async () => {
      try {
        const res = await axios.post(`${API}/auth/session`, {}, { headers: { "X-Session-ID": sessionId }, withCredentials: true });
        setUser(res.data);
        window.history.replaceState({}, document.title, "/account");
        navigate("/account", { state: { user: res.data } });
      } catch {
        navigate("/");
      }
    })();
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen flex items-center justify-center bg-secondary/40">
      <div className="text-center">
        <Loader2 className="w-8 h-8 text-primary animate-spin mx-auto" />
        <p className="mt-3 text-gray-600">Signing you in…</p>
      </div>
    </div>
  );
};

export default AuthCallback;
